import {load, loadMessages} from '@progress/kendo-react-intl';
import likelySubtags from "cldr-data/supplemental/likelySubtags.json";
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from "cldr-data/supplemental/weekData.json";

// Utility function to dynamically load CLDR data and Kendo messages
export async function loadKendoLocale(locale: string): Promise<string> {

    let lang: string = locale;
    switch (locale) {
        case 'pl':
        case 'de':
        case 'en': 
        case 'fr': 
        case 'ru': 
        case 'it': 
        case 'tr': 
        case 'pt': 
        case 'es': 
        {
            break;
        }
        default: {
            lang = "en";
            console.warn(`Unsupported locale: ${lang}, falling back to 'en'`);
            break;
        }
    }
    const [numbers, caGregorian, dateFields, timeZoneNames] = await Promise.all([
        import(`cldr-numbers-full/main/${lang}/numbers.json`),
        import(`cldr-dates-full/main/${lang}/ca-gregorian.json`),
        import(`cldr-dates-full/main/${lang}/dateFields.json`),
        import(`cldr-dates-full/main/${lang}/timeZoneNames.json`),
    ]);
    load(likelySubtags, currencyData, weekData, numbers, caGregorian, dateFields, timeZoneNames);
    const messages = await fetch(`/locales/${lang}/translation.json`).then((r) => r.json());
    loadMessages(messages, lang);
    return lang;
}
